import {Draft} from "../model";

export const getPdfDocumentName = (draft: Draft) => {
  const answers = draft.instance.answers;
  const facilityOrg =
    answers.facilityOrganizationName?.value || "Unknown Organization";
  const facilityName = answers.facilityName?.value || "Unknown Facility";
  const firstName = answers.resident_firstName?.value || "Unknown";
  const lastName = answers.resident_lastName?.value || "Resident";

  return `${facilityOrg} - ${facilityName} - ${firstName} ${lastName}`;
};
